import { useState } from "react";
import PropTypes from "prop-types";

import { StyledButton, StyledTruncate } from "./styles";

const ReadMore = ({ children, lines = 2, less = "Less", more = "More" }) => {
  const [expanded, setExpanded] = useState(false);
  const [truncated, setTruncated] = useState(false);

  const handleTruncate = (truncate) => {
    setTruncated(truncate);
  };

  const toggleLines = (event) => {
    event.preventDefault();

    setExpanded(!expanded);
  };

  return (
    <div>
      <StyledTruncate
        isWrapping={truncated && !expanded}
        lines={!expanded && lines}
        ellipsis={
          <span>
            ...{" "}
            <StyledButton color="secondary" onClick={toggleLines}>
              {more}
            </StyledButton>
          </span>
        }
        onTruncate={handleTruncate}
      >
        {children}
      </StyledTruncate>
      {!truncated && expanded && (
        <span>
          {" "}
          <StyledButton color="secondary" onClick={toggleLines}>
            {less}
          </StyledButton>
        </span>
      )}
    </div>
  );
};

ReadMore.propTypes = {
  children: PropTypes.node.isRequired,
  lines: PropTypes.number,
  less: PropTypes.string,
  more: PropTypes.string,
};

export default ReadMore;
